import React, { useState, useMemo} from "react";
import { humanReadableDateTime } from "../../../../../app/utils";
import { Button } from "../../../../../components/RegularComponents";
// import ApplicationStatusComponent from "../../../BLTCommon/ApplicationStatus";
import { AddInternalNote } from "../Information/AddInternalNote";

const headers = [
    {
        title: "Summary",
        format: (note) => {
            return (<div>
                <h3 style={{margin: 0}}>{note.internalNoteCategory === "InformationMap" ? "Review Notes" : note.internalNoteCategory}</h3>
                <p>{note.note.substr(0, 20)} {note.note.length >20 ? "..." : null}</p>
            </div>)
        }
    },
    {
        key: "createdDate",
        title: "Date",
        sort: (isAscending) => (a, b) => {
            const aDate = a.createdDate
            const bDate = b.createdDate

            if(aDate > bDate) {
                return isAscending ? -1 : 1
            }

            return isAscending ? 1 : -1
        },
        format: (createdDate) => {
            return humanReadableDateTime(createdDate);
        }
    }, 
    {
        key: "createdBy",
        title: "Created by",
        sort: (isAscending) => (a, b) => {
            const aStr = a.createdBy
            const bStr = b.createdBy
            return isAscending ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr)
        }
    }, 
]

export const InternalNotesTable = (props) => {
    const { internalNotes, setInternalNote} = props;

    const [sortingParameters, setSortingParameters] = useState({})
    const [isNewNote, setIsNewNote] = useState(false);

    const rows = useMemo(() => {
        if (!internalNotes) { return [] }
        const header = headers.find(h => h.key === sortingParameters.key)
        if (!header || !header.sort) { return internalNotes }

        const newInternalNotes = [...internalNotes]
        newInternalNotes.sort(header.sort(sortingParameters.isAscending));
        return newInternalNotes

    }, [sortingParameters, internalNotes])

    const getSortIcon = (header) => {
        if (header.key !== sortingParameters?.key) {
            return <i style={{ color: "lightgray" }} className={`fa fa-2x fa-sort`} />
        }
        const activeClass = header.key === sortingParameters?.key ? "active" : ""
        const activeStyle = header.key === sortingParameters?.key ? "#0058a4" : "lightgray"
        const iconStr = sortingParameters?.isAscending ? "fa-sort-asc" : "fa-sort-desc"
        return <i style={{ color: activeStyle }} className={`fa fa-2x ${activeClass} ${iconStr}`} />
    }

    const headerClicked = (header) => () => {
        let modifiedSortingParams = { ...sortingParameters }

        if (header.key === modifiedSortingParams.key) {
            modifiedSortingParams.isAscending = !modifiedSortingParams.isAscending
        } else {
            modifiedSortingParams = { key: header.key, isAscending: false }
        }

        setSortingParameters(modifiedSortingParams)
    }

    if(isNewNote) {
        return <AddInternalNote handleBack={() => setIsNewNote(false)} {...props} />
    }

    return (
        <div className="licence-application-details-panel">
            <div className="row">
                <div className="col-xs-8">
                    <h3>Internal notes history</h3>
                </div>
                <div className="col-xs-4" style={{display:"flex", justifyContent: "flex-end"}}>
                    <Button id={`add-new-internal-note`}
                        className="btn btn-success"
                        style={{height: "3rem"}}
                        text="New note"
                        onClick={() => {
                            setIsNewNote(true)
                        }} 
                    />
                </div>
            </div>
            <div className="row section-row-margin">
                <table>
                    <thead>
                        <tr>
                            {headers.map((h) => (
                                <th key={h.key} onClick={headerClicked(h)}>
                                    <div style={{
                                        display: "inline-flex",
                                        width: "100%",
                                        gap: "0.5rem",
                                        alignItems: "center",
                                        cursor: "arrow"
                                    }}>
                                        <span>{h.title}</span> 
                                        <span style={{ marginRight: "0px 6px" }}>
                                            {getSortIcon(h)}
                                        </span>
                                    </div>
                                </th>
                            ))}
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, index) => (
                            <tr key={index}>
                                {headers.map((header, headerIndex) => {
                                    const key = header.key;
                                    const value = key ? row[key] : row
                                    const formattedValue = header.format ? header.format(value) : value;
                                    return <td key={headerIndex}>{formattedValue}</td>
                                })}
                                <td>
                                    <Button id={`licence-suspension-detail-${index}`}
                                        className={"licence-queue-review-readonly-button"}
                                        buttonType="regular_primary"
                                        text="Details"
                                        onClick={() => {
                                            setInternalNote(row)
                                        }} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>



        </div>
    )
}